import { getMonitorPaygPrice, getMotorVehicleSearchProducts, MonitorPaygPrice } from "Hooks/Api/apiPrice";
import useAsync from "Hooks/useAsync";

export function useApiMonitorPayPrice() {
	const request = useAsync<MonitorPaygPrice>(async () => {
		const res = await getMonitorPaygPrice();
		return res.data;
	}, []);
	return request;
}

export function useApiMotorVehicleSearchProducts() {
	const request = useAsync(async () => {
		const res = await getMotorVehicleSearchProducts();
		return res.data;
	}, []);
	return request;
}